<script setup lang="ts">
import ModalModelBellacloud from "../../components/Modais/ModalModelBellacloud.vue";
import ModalModelPartsVideo from "../../components/Modais/ModalModelPartsVideo.vue";
import ModalMessages from "components/Modais/ModalMessages.vue";
</script>
<template>
  <div class="block block--white mt-3">
    <div class="d-flex">
      <div class="col-lg-5 model-data">
        <h1 class="title model-info">
          {{ name }}
          <span>Videos</span>
        </h1>
        <h3 class="description mt-3 model-info">
          {{ description }}
        </h3>
        <p class="ml-5 mt-3 text model-info">
          {{ text }}
        </p>
      </div>
      <div class="col-lg-7">
        <BoxVideo v-if="videoSelect" :video="videoSelect" />
        <div class="row buttons-video bg-white py-2 px-4">
          <div class="col-lg-2 col-4 d-flex justify-content-center align-items-center">
            <select
              class="form-select py-2"
              aria-label="Default-select-parts"
              v-model="sessionIndex"
            >
              <option selected disabled>{{ translate.sessions }}</option>
              <option :value="index" v-for="(shoot, index) in shoots" :key="shoot.name">
                {{ shoot.name }}
              </option>
            </select>
          </div>
          <div class="col-lg-2 justify-content-center align-items-center div-resolution" v-if="videoSelect">
            <select
              class="form-select py-2"
              aria-label="Default-select-resolution"
              v-model="videoIndex"
            >
              <option selected disabled>{{ translate.resolution }}</option>
              <option :value="index" v-for="(video, index) in videos" :key="video.name">
                {{ video.name }}
              </option>
            </select>
          </div>

          <div
            class="col-lg-2 col-2 d-flex justify-content-center align-items-center mobile-download"
            @click="modalConfirmDownload(partId)"
            v-if="videoSelect"
          >
            <button
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.download }}</span>
              <font-awesome-icon
                :icon="['fas', 'download']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome-icon
              :icon="['fas', 'download']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>

          <div
            class="col-lg-3 col-2 d-flex justify-content-center align-items-center mobile-bellacloud"
            v-if="videoSelect"
          >
            <button
              @click="showModalModelBellacloud(true)"
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.saveBellaCloud }}</span>
              <font-awesome-icon
                :icon="['far', 'bookmark']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome-icon
              @click="showModalModelBellacloud(true)"
              :icon="['far', 'bookmark']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>
          <div class="col-lg-2 col-2 text-center mt-2 mobile-sections" v-if="videoSelect">
            <!-- <font-awesome-icon @click="showModalModelPartsVideo(true)" :icon="['fas', 'table-cells-large']" size="md"
              style="color: #b20000; cursor:pointer; " /> -->
            <span
              @click="showModalModelPartsVideo(true)"
              style="color: #b20000; cursor: pointer"
              >{{ translate.quality }}</span
            >
          </div>
          <div
            class="col-lg-2 col-2 d-flex justify-content-center align-items-center mobile-share"
            v-if="videoSelect"
          >
            <button
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.share }}</span>
              <font-awesome-icon
                :icon="['fas', 'share-nodes']"
                size="md"
                style="color: #b20000; margin-left: 1px"
              />
            </button>
            <font-awesome-icon
              :icon="['fas', 'share-nodes']"
              size="md"
              style="color: #b20000; margin-left: 1px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalModelBellacloud
    @showModalModelBellacloud="showModalModelBellacloud"
    :showCloud="showCloud"
    :imageIdSelected="partId"
    :video="true"
  />
  <ModalModelPartsVideo
    @showModalModelPartsVideo="showModalModelPartsVideo"
    :showPartsVideo="showPartsVideo"
    :parts="shoots"
    :videosIndex="videoIndex"
    :translate="translate"
    @changeResolution="changeResolutionMobile"
  />
  <ModalMessages @showModalMessages="showModalMessages" @solicitaDownload="solicitaDownload" :options="options" />
</template>

<script lang="ts">
import { dataBellacloudAlbums } from "views/pages/data";
import BoxVideo from "./BoxVideo.vue";
import api from "../../api";
import { localeStore } from "stores/locale";
import { mapState } from "pinia";
export default {
  name: "VideosModel",
  props: ["model", "translate"],
  components: {
    BoxVideo,
  },
  computed: {
    ...mapState(localeStore, ["locale"]),
  },
  created() {
    if (this.model) {
      this.getModel();
    }
  },
  watch: {
    model: function () {
      this.getModel();
    },
    videoIndex: function (value) {
      this.videoSelect = this.videos[value];
      this.selectResolution = this.videos[value].name;
    },
    sessionIndex: function (value) {
      this.videos = this.model.shoot[value].videos;
      this.partId = this.model.shoot[value].id;
      this.videoSelect = this.videos[0];
      this.videoIndex = 0;
      this.selectResolution = this.videoSelect?.name;
    },
  },
  data() {
    return {
      name: "",
      description: "",
      text: "",
      sessionIndex: 0,
      shoots: [],
      videoSelect: false,
      selectResolution: "360p",
      showCloud: false,
      showImage: false,
      showPartsVideo: false,
      albums: dataBellacloudAlbums.albums,
      videos: [],
      videoIndex: -1,
      partId: 0,
      options: {
        showModal: false,
        titleModal: "",
        textBodyModal: "",
        textButtonModal: "",
      },
    };
  },
  methods: {
    getModel() {
      this.name = this.model.nameModel;
      this.description = this.model.descriptionModel;
      this.text = this.model.text;
      this.shoots = this.model.shoot;
      this.partId = this.model.shoot[0].id;
      this.videos = this.model.shoot[0].videos;
      this.videoIndex = Number(
        this.videos.indexOf(
          this.videos.find((currObj) => {
            return currObj.name === "HD 720p";
          })
        )
      );

      if (this.videoIndex < 0) this.videoIndex = Number(this.videos.length - 2);
    },
    showModalMessages(data) {
      this.options.showModal = data.message.show;
      this.options.titleModal = data.message.title;
      this.options.textBodyModal = data.message.textBoby;
      this.options.textButtonModal = data.message.textButton;
      this.options.routerName = data.message.routerName;
      this.options.functionOptions = data.message.functionOptions;
      this.options.showClose = data.message.showClose;
    },
    showModalModelBellacloud(value) {
      this.showCloud = value;
    },
    showModalModelPartsVideo(value) {
      this.showPartsVideo = value;
    },
    changeResolutionMobile(resolution: number) {
      this.videoSelect = this.videos[resolution];
      this.selectResolution = this.videos[resolution].name;
      this.videoIndex = resolution;
    },
    modalConfirmDownload(id) {
      this.showModalMessages({
        message: {
          show: true,
          title:
            this.locale == "en"
              ? "Click CONFIRM DOWNLOAD to confirm that you want to download the video"
              : "Clique em CONFIRMAR DOWNLOAD para confirmar que você deseja baixar o vídeo",
          textButton: this.locale == "en" ? 'CONFIRM DOWNLOAD': 'CONFIRMAR DOWNLOAD',
          textBoby: 
            this.locale == "en" 
              ? 'This video will use 1 credit from your account'
              : 'Este vídeo utilizará 1 crédito da sua conta',
          functionOptions: { name: 'solicitaDownload', parameter: id},
          showClose: true
        },
      });    
    },
    async solicitaDownload(id) {
      api
        .get(
          "v1/videoscredits/solicitaDownload/video/" +
            id +
            `?locale=${this.locale ?? this.$route.params.locale ?? "pt-br"}`
        )
        .then(({ data }) => {
          if (!data.error)
            this.showModalMessages({
              message: {
                show: true,
                title:
                  this.locale == "en"
                    ? "Your download is being processed!"
                    : "Seu download está sendo processado!",
                textButton: this.locale == "en" ? "Close" : "Fechar",
                textBoby: data.message,
              },
            });
          else if (
            data.message.includes("Adquira créditos para realizar o download") ||
            data.message.includes("Purchase credits in order to download")
          ) {
            this.showModalMessages({
              message: {
                show: true,
                title:
                  this.locale == "en"
                    ? "Error your download!"
                    : "Falha ao solicitar download!",
                textButton: this.locale == "en" ? "BUY CREDITS" : "COMPRAR CRÉDITOS",
                textBoby: data.message,
                routerName: "AssineOptionsPage",
              },
            });
          } else {
            this.showModalMessages({
              message: {
                show: true,
                title:
                  this.locale == "en"
                    ? "Error your download!"
                    : "Falha ao solicitar download!",
                textButton: this.locale == "en" ? "Close" : "Fechar",
                textBoby: data.message,
              },
            });
          }
        })
        .catch((err) => {
          this.showModalMessages({
            message: {
              show: true,
              title:
                this.locale == "en"
                  ? "Error your download!"
                  : "Falha ao solicitar download!",
              textButton: this.locale == "en" ? "Close" : "Fechar",
              textBoby: err.response.data.message,
            },
          });
        });
    },
  },
};
</script>
<style scoped lang="css">
.block {
  padding: 28px 0;
}

#model-video-box {
  width: 827px;
  height: 465px;
}

.model-info {
  padding-left: 137px;
}

h3 h1 p {
  font-family: "Exo-2";
}

.name-video {
  font-family: "Exo-2";
  font-size: 12px;
  font-weight: bold;
  color: #b20000;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text {
  height: 76px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  max-width: 370px;
}

.video-options {
  height: 19px;
  font-family: "Exo-2";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 19px;
}

.row .buttons-video > .col,
.row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.btn-outline-dark {
  font-size: 14px;
  font-weight: 500;
  border-radius: 30px;
}

.btn-outline-secondary {
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  border: none;
}

.form-select {
  background-color: #fff;
  color: #868686;
  font-size: 14px;
  font-weight: 600;
  font-family: "Exo-2";
  border: none;
  cursor: pointer;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxNiAxNic+PHBhdGggZmlsbD0nbm9uZScgc3Ryb2tlPScjYjIwMDAwJyBzdHJva2UtbGluZWNhcD0ncm91bmQnIHN0cm9rZS1saW5lam9pbj0ncm91bmQnIHN0cm9rZS13aWR0aD0nMicgZD0nbTIgNSA2IDYgNi02Jy8+PC9zdmc+Cg==);
}

.form-select:hover {
  background-color: #6c757d;
  color: #fff;
  border-radius: 30px;
  border: none;
}

.mobile-bellacloud > .fa-bookmark,
.mobile-share > .fa-share-nodes,
.mobile-download > .fa-download,
.mobile-sections {
  display: none;
}

.model-info span{
  font-family: "Exo-2";
  font-size: 25px;
  line-height: 20px;
  display: block;
  width: 100%;
  font-family: "Bebas-Neue";  
}            

@media screen and (max-width: 992px) {
  .model-data,
  .div-resolution,
  .btn-desktop {
    display: none;
  }

  .block {
    padding: 0px;
    margin-top: 0px !important;
  }

  .mobile-bellacloud > .fa-bookmark,
  .mobile-share > .fa-share-nodes,
  .mobile-download > .fa-download,
  .mobile-sections {
    display: block;
  }

  .row >>> #model-video-box {
    margin-bottom: 50px;
  }

  .buttons-video {
    box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    -webkit-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
  }

  .name-video {
    font-family: "Exo-2";
    font-size: 14px;
    font-weight: bold;
    color: #000000;
  }

  #model-video-box {
    width: 100%;
    height: unset;
    right: unset;
    margin-left: 10px;
  }

  .mobile-sections {
    top: -2px;
  }
}
</style>
